<template>
    <div>
      <van-nav-bar
        title="利润提取"
        left-text=""
        left-arrow
        @click-left="$router.push('/account_details')"
      >
        <template #right>
          <span @click="openQchat()" class="chatTextDesign">在线客服</span>
        </template>
      </van-nav-bar>
      <van-row id="rowLines">
        <!-- ------------ account no ----------- -->
  
        <van-row class="rowDesign">
          <van-col span="12">
            <p>合约编号</p>
          </van-col>
          <van-col span="12" style="text-align: right"
            ><p style="color: #000000">{{ accountNum }}</p></van-col
          >
        </van-row>
        <!-- ------------ Current profit ----------- -->
  
        <van-row class="rowDesign">
          <van-col span="12">
            <p>当前盈利</p>
          </van-col>
          <van-col span="12" style="text-align: right"
            ><p style="color: #000000">{{ currentProfit }}元</p></van-col
          >
        </van-row>
        <!-- ------------ Account Balance ----------- -->
  
        <van-row class="rowDesign">
          <van-col span="12">
            <p>账户余额</p>
          </van-col>
          <van-col span="12" style="text-align: right"
            ><p style="color: #000000">{{ accountBalance }}元</p></van-col
          >
        </van-row>
        <!-- ------------ Profit Extraction----------- -->
  
        <van-row class="rowDesign">
          <van-col span="12">
            <p>利润提取</p>
          </van-col>
          <van-col span="12" style="text-align: right"
            ><p style="color: #000000; display: inline-flex; align-items: center">
              <van-field
                v-model="profit_ext"
                name="profit_ext"
                placeholder="请输入提取金额"
              /><span style="margin-left: 4px">元</span>
            </p></van-col
          >
        </van-row>
  
        <!-- ------------ Maximum withdrawal text----------- -->
  
        <van-row style="padding: 20px 0px">
          <van-col span="24" style="text-align: center">
            <p class="warningText">
              <van-icon name="warning" color="#ff0000" size="30" /><span
                >最高提取金额{{ max_amount }}元</span
              >
            </p>
          </van-col>
        </van-row>
  
        <!-- ------------- confirm button --------------- -->
        <div style="display: flex; justify-content: center">
          <van-button
            class="change_nick_btn"
            round
            block
            color="#EE0D25"
            size="small"
            native-type="submit"
            style="height: 50px"
            @click="onSubmit"
          >
            确认
          </van-button>
        </div>
      </van-row>
    </div>
  </template>
  
  <script>
  export default {
    name: "CapitalWithdraw",
    data() {
      return {
        accountNum: "",
        currentProfit: "",
        accountBalance: "",
        profit_ext: "",
        max_amount: "",
      };
    },
    methods: {
      openQchat() {
        if (Capacitor.getPlatform() === "android") {
          //check if android app, if android app use native plugin to open popup
          Browser.open({ url: this.$store.state.chat_server_url });
        } else {
          window.open(this.$store.state.chat_server_url);
        }
      },
      isLogin() {
        let that = this;
        if (!that.$store.state.loginType) {
          that.$router.push("/login");
        }
      },
      getProfitInfo() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "profit_out",
              token: sessionStorage.getItem("token"),
              cid: sessionStorage.getItem("cid"),
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              var info = res.data.data;
              that.accountNum = info.order;
              that.currentProfit = info.profit;
              that.accountBalance = info.balance;
              that.max_amount = info.max;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
              that.$router.push("/account_details");
            }
          });
      },
      onSubmit() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "profit_operate",
              token: sessionStorage.getItem("token"),
              cid: sessionStorage.getItem("cid"),
              number: that.profit_ext,
            },
          })
          .then(function (res) {
            let resData = res.data;
            if (res.data.code == 1) {
              that.$toast.success({
                message: resData.msg,
              });
              that.profit_ext='',
             that.getProfitInfo();
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(resData.msg);
            }
          });
      },
    },
    mounted: function () {
      let that = this;
      that.isLogin();
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
      this.getProfitInfo();
    },
  };
  </script>
  
  <style scoped>
  .chatTextDesign {
    color: #ffffff;
    font-size: 14px;
    padding: 0px 12px;
    border-radius: 6px;
  }
  
  .change_nick_btn {
    position: fixed;
    bottom: 72px;
    width: 80%;
    margin: 20px;
    font-size: 15px;
  }
  
  #rowLines .rowDesign {
    background-color: #fafafa;
    margin: 20px;
    width: unset;
    border-radius: 10px;
    padding: 10px;
  }
  
  .rowDesign p {
    margin: 0px;
    font-size: 14px;
    color: #646566;
  }
  
  .warningText {
    margin: 0px;
    font-size: 14px;
    color: #646566;
    display: inline-flex;
    align-items: center;
  }
  </style>
  <style>
  #rowLines .van-field {
    background-color: #fafafa;
    padding: 0px;
  }
  
  #rowLines .van-field__control {
    text-align: right;
  }
  
  #rowLines .van-cell::after {
    border-bottom: unset;
  }
  </style>


// WEBPACK FOOTER //
// src/components/CapitalWithdraw.vue